import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { Badge, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ApiClient, { HttpResponse } from '../config/ApiClient';
import { useAppContext } from '../context/AppContext';
import { ApiListResponse } from '../object-actions/types/types';

const NotificationButton: React.FC = () => {
    const { mood } = useAppContext();
    const [unreadCount, setUnreadCount] = useState(0);

    // Show red button if user has no mood check-in today
    const hasNoMood = !mood;

    const fetchUnreadCount = async () => {
        try {
            const response: HttpResponse<ApiListResponse<'Notifications'>> = await ApiClient.get(
                `/api/notifications/dashboard/?offset=0&limit=50`
            );

            if (response.success && response.data) {
                const unread = (response.data.results || []).filter(n => !n.seen).length;
                setUnreadCount(unread);
            }
        } catch (err) {
            console.error('Error fetching notification count:', err);
        }
    };

    useEffect(() => {
        fetchUnreadCount();
        // Refresh count periodically
        const interval = setInterval(fetchUnreadCount, 60000); // Every minute
        return () => clearInterval(interval);
    }, []);

    return (
        <IconButton
            component={Link}
            to="/notifications"
            color={hasNoMood ? "error" : "inherit"}
            sx={hasNoMood ? {
                color: 'error.main',
                '&:hover': {
                    backgroundColor: 'error.light',
                    color: 'error.dark'
                }
            } : {}}
        >
            <Badge badgeContent={unreadCount} color="error">
                <NotificationsIcon />
            </Badge>
        </IconButton>
    );
};

export default NotificationButton;

